/* eslint-disable react/jsx-no-bind */
import React, { useCallback, useMemo } from 'react';
import classnames from 'classnames';
import { Flex, Text, TabPane, Label, TextInput, Checkbox } from '@leverege/ui-elements';
import { ModelListEditor, ItemLayoutSelector } from '@leverege/ui-plugin';
import { useValueChange } from '@leverege/ui-hooks';
import I18N from '@leverege/i18n';
import ListModel from "./AggsListModel.js";
import ItemModel from "./AggItemModel.js";
import AggregationListRenderer from "./AggsListRenderer.js";
import Aggregations from "../Aggregations.js";
import S from './AggsListEditor.css';
import AggItemEditor from "./AggItemEditor.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.aggregations.AggregationListEditor');
export default function AggregationListEditor(props) {
  const {
    value,
    onChange,
    eventData,
    objectType,
    delegate,
    blueprint
  } = props;
  const onModelChange = useValueChange(ListModel, props);
  function contentHeader(item) {
    if (item == null) {
      return null;
    }
    let name = ItemModel.getName(item);
    if (name == null) {
      name = item?.model?.type || item?.type || t('unknown');
    }
    return /*#__PURE__*/_jsx(Text, {
      variant: "subtitle",
      children: name
    });
  }
  const onAddAggregation = useCallback(evt => {
    const aggModel = evt.value.create();
    const itemModel = ItemModel.create(aggModel);
    const nModel = ListModel.aggregations().add(value, itemModel);
    onChange({
      data: eventData,
      value: nModel,
      oldValue: value
    });
  }, [value, eventData, onChange]);
  const header = item => {
    const avail = Aggregations.getAggregationsFor(objectType)
    // Removing with a filter for backward compatibility with existing aggregations
    .filter(agg => agg.TYPE !== 'aggregation.filter');
    return /*#__PURE__*/_jsx(Flex, {
      align: "center",
      justify: "space-between",
      children: /*#__PURE__*/_jsx(ItemLayoutSelector, {
        options: avail,
        onSelect: onAddAggregation,
        icon: tIcon('icon', 'fa fa-plus'),
        title: t('title')
      })
    });
  };
  const create = useCallback((item, props) => {
    if (!item) {
      return null;
    }
    return /*#__PURE__*/_jsx(AggItemEditor, {
      value: item,
      objectType: objectType,
      delegate: delegate,
      blueprint: blueprint,
      ...props
    }, item.id);
  }, [objectType, delegate, blueprint]);
  const modelEditorFactory = useMemo(() => ({
    create
  }), [create]);
  const forward = useCallback(e => {
    onChange({
      value: e.value,
      data: eventData
    });
  }, [onChange, eventData]);
  if (value == null) {
    return null;
  }
  return /*#__PURE__*/_jsxs(TabPane, {
    className: S.editor,
    children: [/*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: t('aggregationsTabName'),
      tabId: "aggregations",
      children: /*#__PURE__*/_jsx(ModelListEditor, {
        value: value,
        listClassName: S.list,
        listHeader: header,
        selectionHeader: contentHeader,
        selectedProps: {
          delegate,
          relationship: delegate.relationship
        },
        modelEditorFactory: modelEditorFactory,
        model: ListModel.aggregations(),
        renderer: AggregationListRenderer,
        onChange: forward
      })
    }), /*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: t('optionsTabName'),
      tabId: "options",
      children: /*#__PURE__*/_jsx("div", {
        className: S.pad,
        children: /*#__PURE__*/_jsxs("div", {
          className: classnames(S.grid, S.fill),
          children: [/*#__PURE__*/_jsx(Label, {
            children: t('optionsLabel')
          }), /*#__PURE__*/_jsx(TextInput, {
            eventData: "setVariant",
            onChange: onModelChange,
            value: ListModel.getVariant(value)
          }), /*#__PURE__*/_jsx(Checkbox, {
            label: t('respondsToFilters'),
            eventData: "setIncludePageFilters",
            onChange: onModelChange,
            value: ListModel.getIncludePageFilters(value)
          })]
        })
      })
    })]
  });
}